<template>
  <div>
    <smoothReflow>
      <nav
        id="nav"
        v-if="showMenu"
        v-bind:class="{ showMobileMenu, hideMobileMenu: !showMobileMenu, smallMenu: smallMenu }"
      >
        <button class="borderless toggler" v-on:click="toggleMobileMenu()"></button>
        <span class="pageTitle">{{ $route.meta.title }}</span>
        <ul class="main" @click="toggleMobileMenu()">
          <li v-if="hasMemberApplication && showMemberApplication !== 'false' && isAdminOrEditor">
            <router-link :to="{ name: 'memberApplicationsList' }"
              >Candidaturas
              <span class="notificationCount" v-if="memberApplicationsTotal !== 0">{{
                memberApplicationsTotal
              }}</span></router-link
            >
          </li>
          <li v-if="isAdminOrEditor">
            <router-link :to="{ name: 'membersList' }">{{ orgTerms.memberPlural }}</router-link>
          </li>

          <li v-if="isAdminOrEditor">
            <router-link :to="{ name: 'paymentsList' }">
              {{ orgTerms.membershipPayments }}
            </router-link>
          </li>
          <li v-if="isAdminOrEditor">
            <router-link :to="{ name: 'membershipCardList' }"
              >Cartões de {{ orgTerms.memberSingular }}</router-link
            >
          </li>
          <li v-if="hasTreasury && showTreasury !== 'false' && isAdminOrEditor">
            <router-link :to="{ name: 'treasuryDocList' }">Tesouraria</router-link>
          </li>
          <li v-if="orgType === 'association' && isAdminOrEditor">
            <router-link :to="{ name: 'reportOverview' }">Relatórios</router-link>
          </li>
          <li v-if="isAdminOrEditor">
            <router-link :to="{ name: 'messageList' }">Mensagens</router-link>
          </li>
        </ul>
        <ul id="rightNav">
          <!--@click="toggleMobileMenu()"-->

          <li class="settings" @click="toggleMobileMenu()">
            <template v-if="isAdminOrEditor">
              <router-link :to="{ name: 'userSettings' }">
                <IconSettings stroke="1.25" size="20" color="white" />
                <span class="mobileText"> Definições </span>
              </router-link>
            </template>
            <template v-else>
              <router-link
                :to="{
                  name: 'usersEdit',
                  params: { id: this.$store.state.auth.jwt.CustomUserInfo.ID },
                }"
              >
                <IconSettings stroke="1.25" size="20" color="white" />
                <span class="mobileText"> Definições </span>
              </router-link>
            </template>
          </li>
          <li><UserMenu></UserMenu></li>
        </ul>
      </nav>
      <nav
        id="secondaryNav"
        class="smallerMenu"
        v-else-if="this.$route.meta.module === 'settings'"
      ></nav>
      <nav id="secondaryNav" class="smallerMenu" v-if="this.$route.meta.module === 'quotasEJoias'">
        <ul>
          <li><router-link :to="{ name: 'paymentsList' }">Pagamentos</router-link></li>
          <li><router-link :to="{ name: 'unpaid' }">Dívidas</router-link></li>
        </ul>
      </nav>
      <nav
        id="secondaryNav"
        class="smallerMenu"
        v-if="this.$route.meta.module === 'membershipCards' && showMenu"
      >
        <ul>
          <li><router-link :to="{ name: 'membershipCardList' }">Criar</router-link></li>
          <li>
            <router-link :to="{ name: 'membershipCardVerifyMultiple' }">Verificar</router-link>
          </li>
        </ul>
      </nav>
      <nav
        id="secondaryNav"
        class="smallerMenu"
        v-if="this.$route.meta.module === 'settings' && isAdminOrEditor"
      >
        <ul>
          <li><router-link :to="{ name: 'userSettings' }">Utilizadores</router-link></li>
          <li>
            <router-link :to="{ name: 'memberSettings' }">{{ orgTerms.memberPlural }}</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'membershipCardSettings' }"
              >Cartões de {{ orgTerms.memberPlural }}</router-link
            >
          </li>
          <li v-if="showMemberApplication !== 'false'">
            <router-link :to="{ name: 'memberApplicationSettings' }"
              >Candidaturas de {{ orgTerms.memberPlural }}</router-link
            >
          </li>
          <li><router-link :to="{ name: 'messageSettings' }">Mensagens</router-link></li>
          <li v-if="showTreasury !== 'false'">
            <router-link :to="{ name: 'treasuryDocSettings' }">Tesouraria</router-link>
          </li>
          <li><router-link :to="{ name: 'developers' }">Programadores</router-link></li>
        </ul>
      </nav>
    </smoothReflow>
  </div>
</template>

<script>
import UserMenu from './UserMenu.vue'
import { mapState, mapGetters } from 'vuex'
import { orgTerms } from '@/terminology'
import { IconSettings } from '@tabler/icons-vue'

export default {
  name: 'NavigationC',
  components: { UserMenu, IconSettings },
  data() {
    return {
      orgTerms: orgTerms,
      showTreasury: import.meta.env.VITE_SHOW_TREASURY,
      showMemberApplication: import.meta.env.VITE_SHOW_MEMBER_APPLICATION,
      showMobileMenu: false,
      smallMenu: true,
    }
  },
  computed: {
    ...mapState({
      settings: (state) => state.settings.list,
      memberApplicationsTotal: (state) => state.memberApplications.total,
    }),
    ...mapGetters({
      isLoggedin: 'auth/isLoggedin',
      orgType: 'settings/orgType',
    }),
    userRole() {
      if (typeof this.$store.state.auth.jwt.CustomUserInfo === 'undefined') {
        return null
      }
      return this.$store.state.auth.jwt.CustomUserInfo.Role
    },
    isAdminOrEditor() {
      return ['admin', 'editor'].includes(this.userRole)
    },
    hasMemberApplication() {
      if (typeof this.$store.getters['settings/listByName'].hasMemberApplication === 'undefined') {
        return false
      }
      if (this.$store.getters['settings/listByName'].hasMemberApplication.value === 'true') {
        return true
      } else {
        return false
      }
    },
    hasTreasury() {
      const hasTreasurySetting = this.settings.find((s) => {
        return s.name === 'hasTreasury'
      })
      if (!hasTreasurySetting) {
        return false
      }
      return hasTreasurySetting.value === 'true'
    },
    showMenu() {
      let showMenu = false
      if (this.isLoggedin) {
        showMenu = true
      }
      if (['recover', 'unpaidSingle'].includes(this.$route.name)) {
        showMenu = false
      }
      return showMenu
    },
  },
  methods: {
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    hideMobileMenu() {
      this.showMobileMenu = false
    },
    hideMobileMenuOnResize() {
      this.hideMobileMenu()
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.hideMobileMenuOnResize)
  },
  mounted() {
    //count Pending applications
    if (this.isLoggedin) {
      this.$store.dispatch('memberApplications/list')
    }

    window.addEventListener('resize', this.hideMobileMenuOnResize)
  },
}
</script>

<style lang="scss" scoped>
@use '@/scss/_variables.scss';
nav {
  display: flex;
  position: relative;
  transition: all 0.25s;
  font-weight: 300;
  min-height: 35px;
  :deep(button) {
    font-weight: 300;
  }
  .router-link-active {
    font-weight: 500;
  }
}
a {
  text-decoration: none;
}

#nav {
  background: var(--slightly-darker-primary) !important;
  font-size: 0.81rem;
  .toggler {
    margin: 0;
    padding: 0;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    color: white;
    background: url('/src/assets/bars-solid.svg') transparent no-repeat center;
    background-size: 20px 20px;
    display: block;
    position: absolute;
    top: calc(var(--sp) * 0.48);
    left: var(--sp);
  }
  .pageTitle {
    color: white;
    position: absolute;
    left: calc(var(--sp) * 3);
    top: calc(var(--sp) * 0.5);
    font-weight: bold;
  }
  .toggler:hover::before {
    background-color: transparent !important;
  }
}

@media only screen and (max-width: calc(1000px - 1px)) {
  #nav .pageTitle {
    display: block;
  }
  .showMobileMenu {
    padding-top: 60px;
    min-height: 100vh;
    .main,
    #rightNav {
      text-align: center;
      li {
        padding-top: calc(var(--sp) * 1);
        padding-bottom: calc(var(--sp) * 1);
      }
    }
  }
  .hideMobileMenu {
    > ul {
      display: none;
    }
  }
  #nav {
    flex-direction: column;
    gap: var(--sp);
    ul {
      flex-direction: column;
      li {
        width: 100%;
      }
      ul {
        background-color: rgba(0, 0, 0, 0.1);
        width: 100%;
      }
    }
    .main {
      flex-grow: 0;
    }
    li {
      margin-top: calc(var(--sp) / 2);
      margin-bottom: calc(var(--sp) / 2);
    }
  }
  #rightNav li {
    max-height: initial !important;
  }
}

@media only screen and (min-width: 1000px) {
  #nav .pageTitle {
    display: none;
  }
  #nav .toggler {
    display: none;
  }
}

.main {
  flex-grow: 1;
}
ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: left;
  li {
    white-space: pre;
    max-height: 20px;
    margin-left: calc(var(--sp) / 2);
    margin-right: calc(var(--sp) / 2);
    padding: 0 calc(var(--sp) / 2);
    a {
      color: white;
    }
    a.router-link-active {
      text-decoration: none;
    }
  }
}

#rightNav {
  position: relative;
  top: -9px;
}
@media only screen and (max-width: 1000px) {
  #rightNav {
    padding-right: 0;
  }
}

#rightNav > li {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-top: 0;
}

#rightNav > li > ul > li {
  display: block;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  white-space: nowrap;
}
#rightNav > li > ul > li > ul {
  flex-direction: column;
  z-index: 1;
  padding-top: calc(var(--sp) / 2);
  padding-bottom: var(--sp);
}
#rightNav > li > ul > li > ul > li {
  padding-top: var(--sp);
  padding-bottom: 0;
}

.settings {
  padding-top: 8px !important;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media print {
  nav {
    display: none;
  }
}

.mobileText {
  display: none;
}

@media only screen and (max-width: 1000px) {
  .mobileText {
    display: inline-block;
    padding-left: var(--sp);
    color: white;
  }
}

#secondaryNav {
  background-color: var(--header-background) !important;
  border-bottom: 1px solid var(--header-background-darker);
  box-shadow: var(--default-shadow);
  min-height: 40px;
  ul {
    flex-wrap: wrap;
    gap: calc(var(--sp) * 1.5);

    padding: calc(var(--sp) / 2) var(--sp);
    li {
      margin: 0;
      padding: 0;
    }
  }
}
</style>

<style lang="scss">
#nav .main button {
  white-space: nowrap;
}
</style>
